import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Notice from '../components/Notice';
import Stamp from '../components/Stamp';
import { IMG } from '../data/site';

export default function TentangPage() {
  return (
    <>
      <section className="bg-[#1F140E] grain relative text-[#FDFBF7] overflow-hidden">
        <div className="relative z-10 mx-auto max-w-6xl px-5 py-14 sm:py-20">
          <Breadcrumbs items={[{ name: 'Tentang', path: '/tentang/' }]} />
          <div className="mt-8 flex flex-col sm:flex-row sm:items-end gap-8 justify-between">
            <div className="max-w-2xl">
              <p className="font-pricemono text-[11px] tracking-[0.25em] uppercase text-[#E5A83B]">
                Sejak 1973 · Surakarta
              </p>
              <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4">
                Setengah Abad Menjaga Rasa Khas Solo
              </h1>
            </div>
            <Stamp size={120} dark />
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-16 sm:py-24 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#2B1B12] tracking-tight">
            Dari Dapur Kecil di Widuran
          </h2>
          <div className="mt-5 space-y-4 text-base sm:text-lg leading-relaxed text-[#3f3730]">
            <p>
              Ayam Goreng Widuran berdiri pada tahun 1973 di kawasan Kepatihan Kulon, tepatnya di
              Jalan Sutan Syahrir No. 71, Solo — jalan kecil yang kemudian lekat dengan nama rumah
              makan ini. Nama “Widuran” sendiri diambil dari kawasan tempat usaha ini dirintis.
            </p>
            <p>
              Sebagai usaha keluarga yang diteruskan lintas generasi, Widuran setia pada racikan
              lamanya: ayam kampung pilihan yang digoreng hingga garing keemasan, lalu ditaburi
              kremesan — serpihan gurih renyah yang menjadi ciri khas setiap piringnya.
            </p>
            <p>
              Kini, selain outlet utama di Widuran, cita rasa yang sama hadir di Sudirman Square,
              Solo, dan di Jalan Imam Bonjol, Denpasar, Bali.
            </p>
          </div>

          <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#2B1B12] tracking-tight mt-14">
            Terbuka demi Kepercayaan Pelanggan
          </h2>
          <div className="mt-5 space-y-4 text-base sm:text-lg leading-relaxed text-[#3f3730]">
            <p>
              Pada Mei 2025, kami secara terbuka menyatakan bahwa produk Ayam Goreng Widuran
              non-halal. Pernyataan ini kami sampaikan sendiri, disertai label yang jelas di
              outlet, etalase, dan kemasan — karena bagi kami, kejujuran kepada pelanggan adalah
              bagian dari resep yang tak boleh berubah.
            </p>
            <p>
              Kami menghargai keputusan setiap pelanggan, dan berterima kasih kepada mereka yang
              telah membersamai rumah makan ini lebih dari lima dekade.
            </p>
          </div>
          <div className="mt-8">
            <Notice variant="box" />
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="grid gap-5 lg:sticky lg:top-32">
            <img
              src={IMG.heritage}
              alt="Suasana penyajian hidangan ayam khas rumah makan tradisional"
              width="1400"
              height="900"
              loading="lazy"
              className="rounded-lg w-full aspect-[4/3] object-cover shadow-md"
            />
            <img
              src={IMG.urap}
              alt="Hidangan pendamping khas rumah makan Jawa"
              width="1000"
              height="750"
              loading="lazy"
              className="rounded-lg w-full aspect-[4/3] object-cover shadow-md lg:ml-10"
            />
          </div>
        </div>
      </section>

      <section className="bg-[#F5EFE6] border-t border-[#E2D3BE] py-16">
        <div className="mx-auto max-w-6xl px-5 flex flex-col md:flex-row md:items-center gap-8 justify-between">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#2B1B12] tracking-tight max-w-xl">
            Rasakan sendiri ayam goreng kremes yang dijaga sejak 1973.
          </h2>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/menu/"
              data-testid="tentang-cta-menu"
              className="inline-flex items-center bg-[#C84B27] text-[#FDFBF7] font-semibold px-7 py-3.5 rounded-md hover:bg-[#a93d1f] transition-colors active:scale-95"
            >
              Lihat Menu
            </Link>
            <Link
              to="/lokasi/"
              data-testid="tentang-cta-lokasi"
              className="inline-flex items-center border-2 border-[#2B1B12] text-[#2B1B12] font-semibold px-7 py-3.5 rounded-md hover:bg-[#2B1B12] hover:text-[#FDFBF7] transition-colors active:scale-95"
            >
              Lihat Lokasi
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
